import { Modal } from "../../../../../../../_metronic/elements/Modal";
import { useIsMobile } from "../../../../../../shared/responsive";
import "../Prescription/PrescriptionForm.scss";

const ImageAmbientModal = ({ open, setOpen, children }) => {
  const isMobile = useIsMobile();

  return (
    <>
      <Modal open={open} setOpen={setOpen}>
        <div className={`modal-dialog modal-dialog-scrollable prescription-modal-dialog ${isMobile ? "prescription-modal-dialog--mobile" : "modal-dialog-centered prescription-modal-dialog--desktop prescription-modal-dialog--image-ambient"}`.trim()}>
          <div className="modal-content">
            {children}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ImageAmbientModal;
